import { FC } from "react";
import { Col, Row, Typography } from "antd";
import * as _ from "lodash";

import { classname } from "@ctra/utils";
import styles from "./ProgressBar.module.less";

const { Text } = Typography;

export interface ProgressBarProps {
  /**
   * label of slider
   */
  label: string;
  /**
   * percentage value of progress
   */
  progress: number;
}

/**
 * Game plan progress slider component
 * @param {string} label
 * @param {number} progress
 * @return {JSX.Element}
 * @constructor
 */
const ProgressBar: FC<ProgressBarProps> = ({ label, progress }) => (
  <Row gutter={[0, 8]} justify="center" align="middle">
    <Col span={24} className={classname("ctra-gamePlan-ProgressBar", styles.ProgressBar)}>
      <div className={styles.ProgressBackground}>
        <div className={styles.ProgressBar} style={{ width: `${_.clamp(progress, 0, 100)}%` }} />
      </div>
    </Col>
    <Col className={styles.Text}>
      <Text type="secondary">{label}</Text>
    </Col>
  </Row>
);

export default ProgressBar;
